// extracted by mini-css-extract-plugin
export default {"light-green":"#1dc31a","dark-green":"#2ca622","red":"#a62222","white":"#fff"};